module.exports = __webpack_public_path__ + "img/video_1.a51a9637.png";